/**
 * Configuration required for Amplify.
 * Ref: https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/
 */

export const envConfig = {
  Auth: {
    // (required) only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: 'us-west-2:8f115444-7721-4cce-a9fd-806de3c77a33',

    // (required)- Amazon Cognito Region
    region: 'us-west-2',

    // (optional) - Amazon Cognito User Pool ID
    userPoolId: 'us-west-2_Up3HqVRcX',

    // (optional) - Amazon Cognito Web Client ID (26-char alphanumeric string, App client secret needs to be disabled)
    userPoolWebClientId: '6mk1r14fkhia5m3uotmk67p0qp',

    // (optional) - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,

    // (optional) - Hosted UI configuration
    oauth: {
      domain: 'finance-allocation-access-control-prod' + '.auth.us-west-2.amazoncognito.com',
      redirectSignIn: 'https://' + window.location.host + '/',
      redirectSignOut: 'https://' + window.location.host + '/',
      scope: ['openid'],
      responseType: 'code',
    },
  },
  API: {
    endpoints: [
      {
        name: 'FinanceAllocationsService',
        endpoint: 'https://api.allocations.finergy.amazon.dev',
      },
      {
        name: 'TaskSchedulingService',
        endpoint: 'https://api.taskscheduling.finergy.amazon.dev',
      },
      {
        name: 'FAEAuthService',
        endpoint: 'https://authz.allocations.finergy.amazon.dev',
      },
    ],
  },
  Storage: {
    AWSS3: {
      bucket: 'allocations-driver-mapping-prod',
      region: 'us-west-2',
    },
  },
};
